// 통영 판별 — customer_id=52 만으로는 dev/local 등 다른 서버에서도 같은 id 를 가진
//   테스트 계정이 오작동할 수 있어, 운영 서버(kr.neverlosewater.com) 인지도 함께 확인한다.
export function isTongyeongCustomer() {
  if (String(sessionStorage.select_customer_id) !== '52') return false
  if (typeof window === 'undefined' || !window.location) return false
  return (window.location.hostname || '').toLowerCase() === 'kr.neverlosewater.com'
}

// 고객사 52(통영) 는 누수음 기본 조회시각이 13:00 (그 외 03:00) — 당일 그 시각이 아직
//   안 지났으면 "오늘 13시" 데이터가 없어 리스트가 비어보이므로 전날 같은 시각으로 폴백.
//   DashboardView(리스트 조회)와 MapPanel(지도 상단 날짜 표시)이 동일 규칙을 공유해야
//   "지도 상단 날짜 == 누수목록을 가져온 날짜"가 항상 일치한다.
export function resolveLeakDate(dateStr, hour) {
  if (!isTongyeongCustomer()) return dateStr
  const now = new Date()
  const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
  if (dateStr !== todayStr || now.getHours() >= Number(hour)) return dateStr
  now.setDate(now.getDate() - 1)
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
}
